import { NAVITEM, CHANGE_NAVITEM } from 'src/State-Management/Actions/ActionTypes'

const NavItemReducer = function (state = '', action) {
    switch (action.type) {
        case NAVITEM:
            return state;
        case CHANGE_NAVITEM:
            return action.payload;
        default:
            return state;
    }
}

export default NavItemReducer